export default "__VITE_ASSET__BWG0B159__"